module.exports = __webpack_public_path__ + "img/cybersecurity-img-4.c7d4efa8.jpg";